import { useState } from 'react';
import Button from '@mui/material/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import { contactUsDomain } from '../../domain';

const SubscribeForm = () => {
    const [formData, setFormData] = useState({
        Email: '',
    });

    const [successfullySubmitted, setSuccessfullySubmitted] = useState(null);

    const subscribeFormSubmit = async (e) => {
        e.preventDefault();
        await contactUsDomain.subscribeToNewsletter(formData.Email);
        setSuccessfullySubmitted(true);
    };

    const ontxtSubscribeEmailChange = (event) => {
        setFormData({ Email: event.target.value });
    };

    const newsletterSignUpTitle = 'Thanks for signing up! We’ll keep in touch.';

    return (
        <>
            {!successfullySubmitted && (
                <form
                    className="py-4"
                    id="o-club-subscribe-form"
                    onSubmit={subscribeFormSubmit.bind(this)}
                    method="POST"
                >
                    <div className="row">
                        <div className="col-7">
                            <input
                                type="text"
                                id="Email"
                                required
                                name="Email"                                
                                placeholder="Email address"
                                value={formData.Email}
                                onChange={ontxtSubscribeEmailChange.bind(this)}
                            />                            
                        </div>

                        <div className="col-4">
                            <Button type="submit" className="green-button" id="club-subscribe-button">
                                Subscribe
                            </Button>
                        </div>
                    </div>
                </form>
            )}
            {successfullySubmitted && <p className="grey-p-oclub">{newsletterSignUpTitle}</p>}
        </>
    );
};

export default SubscribeForm;
